module.exports = __webpack_public_path__ + "static/img/role-en.5afbe6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-1/role-en.png
// module id = ZGlQ
// module chunks = 1